export const USER_REQUEST = "USER_REQUEST";
export const USER_SUCCESS = "USER_SUCCESS";
export const USER_SUCCESS_RENEW = "USER_SUCCESS_RENEW";
export const USER_ERROR = "USER_ERROR";
export const PROFILE_EDIT = "PROFILE_EDIT";
export const ACCOUNT_DELETE = "ACCOUNT_DELETE";